(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-community]');
    sections.forEach((section) => {
      const track = section.querySelector('[data-community-track]');
      const tiles = Array.from(section.querySelectorAll('[data-community-tile]'));
      const prev = section.querySelector('[data-community-prev]');
      const next = section.querySelector('[data-community-next]');
      if (!track || tiles.length < 2) return;

      let active = Math.floor((tiles.length - 1) / 2);

      function update() {
        tiles.forEach((tile, i) => {
          const offset = i - active;
          const abs = Math.abs(offset);
          tile.style.setProperty('--offset', offset);
          tile.style.setProperty('--abs', abs);
          tile.classList.toggle('is-active', i === active);
        });
      }

      function go(delta) {
        const n = tiles.length;
        active = (active + delta + n) % n;
        update();
      }

      tiles.forEach((tile, i) => {
        tile.addEventListener('click', (e) => {
          if (i !== active) {
            e.preventDefault();
            active = i;
            update();
          }
        });
      });

      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));

      let pointerStartX = null;
      let pointerMoved = false;
      track.addEventListener('pointerdown', (e) => {
        pointerStartX = e.clientX;
        pointerMoved = false;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', (e) => {
        if (pointerStartX === null) return;
        if (Math.abs(e.clientX - pointerStartX) > 6) pointerMoved = true;
      });
      const endDrag = (e) => {
        if (pointerStartX === null) return;
        const dx = e.clientX - pointerStartX;
        track.classList.remove('is-dragging');
        if (Math.abs(dx) > 40) {
          go(dx > 0 ? -1 : 1);
        }
        pointerStartX = null;
        setTimeout(() => { pointerMoved = false; }, 0);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('click', (e) => {
        if (pointerMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { go(-1); }
        else if (e.key === 'ArrowRight') { go(1); }
      });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var sections = document.querySelectorAll('[data-fbt]');
      sections.forEach(function (root) {
        if (root.__fbtBound) return;
        root.__fbtBound = true;

        var combosEl = root.querySelector('[data-fbt-combos]');
        var combos = [];
        try { combos = JSON.parse(combosEl.textContent); } catch (e) { combos = []; }

        var totalEl = root.querySelector('[data-fbt-total]');
        var wasEl = root.querySelector('[data-fbt-was]');
        var saveEl = root.querySelector('[data-fbt-savings]');
        var addBtn = root.querySelector('[data-upsell-add-all]');
        var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-fbt-toggle]'));
        var shots = root.querySelectorAll('[data-fbt-shot]');

        /* The current product's live variant id comes from the main product form. */
        function currentVariantId() {
          var input = document.querySelector('[data-product-form] [data-variant-id], [data-product-template] [data-variant-id]');
          return input ? input.value : '';
        }

        function addonVariantId(item) {
          var sel = item.querySelector('[data-fbt-variant]');
          if (sel) return sel.value;
          return item.getAttribute('data-variant-id') || '';
        }

        function mask() {
          var m = 0;
          toggles.forEach(function (t) {
            if (t.checked) m += (1 << parseInt(t.getAttribute('data-index'), 10));
          });
          return m;
        }

        function setHidden(el, hide) {
          if (!el) return;
          if (hide) el.setAttribute('hidden', '');
          else el.removeAttribute('hidden');
        }

        function syncVariantIds() {
          var ids = [];
          var cur = currentVariantId();
          if (cur) ids.push(cur);
          root.querySelectorAll('[data-fbt-addon]').forEach(function (item) {
            var toggle = item.querySelector('[data-fbt-toggle]');
            if (toggle && toggle.checked) {
              var id = addonVariantId(item);
              if (id) ids.push(id);
            }
          });
          if (addBtn) addBtn.setAttribute('data-variant-ids', ids.join(','));
        }

        function render() {
          var m = mask();
          var c = combos[m];
          if (c) {
            if (totalEl) totalEl.textContent = c.t;
            if (wasEl) { wasEl.textContent = c.w; setHidden(wasEl, !c.hasW); }
            if (saveEl) {
              saveEl.textContent = 'You save ' + c.s;
              setHidden(saveEl, !c.hasS);
            }
          }
          /* Dim de-selected rows + their visual shot. */
          root.querySelectorAll('[data-fbt-addon]').forEach(function (item) {
            var toggle = item.querySelector('[data-fbt-toggle]');
            var off = toggle && !toggle.checked;
            item.classList.toggle('is-off', !!off);
            var idx = item.getAttribute('data-index');
            var shot = root.querySelector('[data-fbt-shot="' + idx + '"]');
            if (shot) shot.classList.toggle('is-off', !!off);
          });
          syncVariantIds();
        }

        root.addEventListener('change', function (e) {
          if (e.target.matches('[data-fbt-toggle], [data-fbt-variant]')) render();
        });

        /* Keep the bundle's current-item variant fresh when the shopper changes
           size/colour on the main product form, and right before the add fires. */
        document.addEventListener('change', function (e) {
          if (e.target.closest('[data-product-form]')) syncVariantIds();
        });
        if (addBtn) addBtn.addEventListener('pointerdown', syncVariantIds);

        render();
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    function buildReel(char) {
      const letter = document.createElement("span");
      letter.className = "slot-letter";
      letter.setAttribute("aria-hidden", "true");

      const inner = document.createElement("span");
      inner.className = "slot-letter__inner";

      const head = document.createElement("span");
      head.textContent = char;
      inner.appendChild(head);

      const tail = document.createElement("span");
      tail.textContent = char;
      inner.appendChild(tail);

      letter.appendChild(inner);
      return letter;
    }

    function slotify(host) {
      const original = host.textContent.trim();
      if (!original || host.dataset.slotReady === "true") return;

      const sr = document.createElement("span");
      sr.className = "visually-hidden";
      sr.textContent = original;

      const visual = document.createElement("span");
      visual.setAttribute("aria-hidden", "true");

      [...original].forEach((char, i) => {
        if (char === " ") {
          visual.appendChild(document.createTextNode(" "));
          return;
        }
        const letter = buildReel(char);
        letter.style.setProperty("--slot-delay", `${i * 40}ms`);
        visual.appendChild(letter);
      });

      host.textContent = "";
      host.appendChild(sr);
      host.appendChild(visual);
      host.dataset.slotReady = "true";
    }

    function init() {
      document.querySelectorAll(".site-header__nav [data-slot]").forEach(slotify);
      initMobileNav();
      initMegaMenu();
      initMegaDrawer();
      initCartDrawer();
      initStickyState();
    }

    /* Desktop mega panel.
       Hover opens it on pointer devices while leaving the trigger a real link,
       so "Shop" still navigates on click. Without hover (touch), the first tap
       opens the panel instead of navigating — otherwise the panel would be
       unreachable on a tablet. */
    function initMegaMenu() {
      if (window.__megaBound) return;

      const trigger = document.querySelector("[data-mega-trigger]");
      const panel = document.querySelector("[data-mega-panel]");
      const header = document.querySelector("[data-site-header]");
      if (!trigger || !panel || !header) return;

      window.__megaBound = true;

      const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      let openTimer = null;
      let closeTimer = null;

      function clearTimers() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      }

      function open() {
        clearTimers();
        panel.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }

      function close() {
        clearTimers();
        panel.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      }

      function isOpen() {
        return panel.classList.contains("is-open");
      }

      if (canHover) {
        const scheduleOpen = () => {
          clearTimers();
          openTimer = setTimeout(open, 70);
        };
        const scheduleClose = () => {
          clearTimers();
          closeTimer = setTimeout(close, 220);
        };

        trigger.addEventListener("pointerenter", scheduleOpen);
        trigger.addEventListener("pointerleave", scheduleClose);
        panel.addEventListener("pointerenter", clearTimers);
        panel.addEventListener("pointerleave", scheduleClose);
      } else {
        trigger.addEventListener("click", (e) => {
          if (!isOpen()) {
            e.preventDefault();
            open();
          }
        });
        document.addEventListener("click", (e) => {
          if (!isOpen()) return;
          if (!header.contains(e.target)) close();
        });
      }

      /* Keyboard: the panel opens on focus and closes once focus leaves the
         header entirely, so it can be tabbed through in order. */
      trigger.addEventListener("focus", open);
      header.addEventListener("focusout", () => {
        requestAnimationFrame(() => {
          if (!header.contains(document.activeElement)) close();
        });
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && isOpen()) {
          close();
          trigger.focus();
        }
      });
    }

    /* Mobile drawer accordion. Height is animated explicitly because `auto`
       is not an interpolable value. */
    function initMegaDrawer() {
      if (window.__megaDrawerBound) return;

      const toggle = document.querySelector("[data-mega-drawer-toggle]");
      const panel = document.querySelector("[data-mega-drawer-panel]");
      if (!toggle || !panel) return;

      window.__megaDrawerBound = true;

      function settle(done) {
        panel.addEventListener("transitionend", function handler(e) {
          if (e.propertyName !== "height" || e.target !== panel) return;
          panel.removeEventListener("transitionend", handler);
          panel.style.height = "";
          panel.classList.remove("is-animating");
          if (done) done();
        });
      }

      toggle.addEventListener("click", () => {
        const expanded = toggle.getAttribute("aria-expanded") === "true";

        if (expanded) {
          panel.style.height = panel.scrollHeight + "px";
          panel.classList.add("is-animating");
          requestAnimationFrame(() => { panel.style.height = "0px"; });
          settle(() => { panel.hidden = true; });
          toggle.setAttribute("aria-expanded", "false");
        } else {
          panel.hidden = false;
          const target = panel.scrollHeight;
          panel.style.height = "0px";
          panel.classList.add("is-animating");
          requestAnimationFrame(() => { panel.style.height = target + "px"; });
          settle();
          toggle.setAttribute("aria-expanded", "true");
        }
      });
    }

    function initMobileNav() {
      if (window.__navDrawerBound) return;
      window.__navDrawerBound = true;

      let lastFocused = null;

      function getDrawer() { return document.querySelector("[data-nav-drawer]"); }
      function getToggle() { return document.querySelector("[data-nav-toggle]"); }
      function getBackdrop() { return document.querySelector("[data-nav-backdrop]"); }
      function isOpen() {
        const d = getDrawer();
        return d ? d.classList.contains("is-open") : false;
      }
      function preventBackdropTouch(e) {
        if (e.target.closest("[data-nav-drawer]")) return;
        e.preventDefault();
      }

      function open() {
        const drawer = getDrawer();
        const toggle = getToggle();
        const backdrop = getBackdrop();
        if (!drawer || !toggle) return;
        lastFocused = document.activeElement;
        drawer.classList.add("is-open");
        if (backdrop) backdrop.classList.add("is-open");
        document.documentElement.classList.add("is-nav-open");
        document.body.classList.add("is-nav-open");
        document.addEventListener("touchmove", preventBackdropTouch, { passive: false });
        toggle.setAttribute("aria-expanded", "true");
        drawer.setAttribute("aria-hidden", "false");
        const firstFocusable = drawer.querySelector("button, input, a");
        if (firstFocusable) requestAnimationFrame(() => firstFocusable.focus());
      }
      function close() {
        const drawer = getDrawer();
        const toggle = getToggle();
        const backdrop = getBackdrop();
        if (drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
        }
        if (backdrop) backdrop.classList.remove("is-open");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("is-nav-open");
        document.body.classList.remove("is-nav-open");
        document.removeEventListener("touchmove", preventBackdropTouch, { passive: false });
        if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      }

      document.addEventListener("click", (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        if (target.closest("[data-nav-toggle]")) {
          e.preventDefault();
          isOpen() ? close() : open();
          return;
        }
        if (target.closest("[data-nav-close]")) {
          e.preventDefault();
          close();
          return;
        }
        if (target.closest("[data-nav-backdrop]")) {
          close();
          return;
        }
        if (isOpen() && target.closest("[data-nav-drawer] a")) {
          close();
        }
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && isOpen()) close();
      });

      window.addEventListener("resize", () => {
        if (window.innerWidth > 989 && isOpen()) close();
      });
    }

    function initCartDrawer() {
      if (window.__cartDrawerBound) return;
      window.__cartDrawerBound = true;

      let lastFocused = null;
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

      function getDrawer() { return document.querySelector("[data-cart-drawer]"); }
      function getToggle() { return document.querySelector("[data-cart-toggle]"); }
      function getBackdrop() { return document.querySelector("[data-nav-backdrop]"); }

      function applySection(html) {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const newDrawer = parsed.querySelector("[data-cart-drawer]");
        const currentDrawer = getDrawer();
        if (newDrawer && currentDrawer) {
          if (currentDrawer.classList.contains("is-open")) {
            newDrawer.classList.add("is-open");
            newDrawer.setAttribute("aria-hidden", "false");
          }
          currentDrawer.replaceWith(newDrawer);
        }
        const cartIcon = document.querySelector(".site-header__cart");
        const newCount = parsed.querySelector("[data-cart-count]");
        const currentCount = document.querySelector("[data-cart-count]");
        if (newCount && currentCount) currentCount.textContent = newCount.textContent;
        else if (newCount && cartIcon) cartIcon.appendChild(newCount.cloneNode(true));
        else if (!newCount && currentCount) currentCount.remove();
      }

      async function removeLine(line, el) {
        if (el) {
          el.style.pointerEvents = "none";
          el.style.opacity = "0.4";
        }
        const formData = new FormData();
        formData.set("line", String(line));
        formData.set("quantity", "0");
        formData.set("sections", "header");
        try {
          const res = await fetch(cartRoot + "cart/change.js", {
            method: "POST",
            body: formData,
            headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          });
          const data = await res.json();
          if (data && data.sections && data.sections.header) applySection(data.sections.header);
        } catch (err) {
          if (el) {
            el.style.pointerEvents = "";
            el.style.opacity = "";
          }
        }
      }
      function isOpen() {
        const d = getDrawer();
        return d ? d.classList.contains("is-open") : false;
      }
      function closeNavIfOpen() {
        const navDrawer = document.querySelector("[data-nav-drawer]");
        if (!navDrawer || !navDrawer.classList.contains("is-open")) return;
        navDrawer.classList.remove("is-open");
        navDrawer.setAttribute("aria-hidden", "true");
        const navToggle = document.querySelector("[data-nav-toggle]");
        if (navToggle) navToggle.setAttribute("aria-expanded", "false");
      }
      function preventBackdropTouch(e) {
        if (e.target.closest("[data-cart-drawer]")) return;
        e.preventDefault();
      }

      function open() {
        const drawer = getDrawer();
        const toggle = getToggle();
        const backdrop = getBackdrop();
        if (!drawer) return;
        closeNavIfOpen();
        lastFocused = document.activeElement;
        drawer.classList.add("is-open");
        if (backdrop) backdrop.classList.add("is-open");
        document.documentElement.classList.add("is-nav-open");
        document.body.classList.add("is-nav-open");
        document.addEventListener("touchmove", preventBackdropTouch, { passive: false });
        if (toggle) toggle.setAttribute("aria-expanded", "true");
        drawer.setAttribute("aria-hidden", "false");
        const firstFocusable = drawer.querySelector("button, a, input");
        if (firstFocusable) requestAnimationFrame(() => firstFocusable.focus());
      }
      function close() {
        const drawer = getDrawer();
        const toggle = getToggle();
        const backdrop = getBackdrop();
        if (drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
        }
        if (backdrop) backdrop.classList.remove("is-open");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("is-nav-open");
        document.body.classList.remove("is-nav-open");
        document.removeEventListener("touchmove", preventBackdropTouch, { passive: false });
        if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      }

      document.addEventListener("click", (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const toggleEl = target.closest("[data-cart-toggle]");
        if (toggleEl) {
          /* Let modifier-clicks (cmd/ctrl/shift/middle) fall through to the href so power users can still open /cart in a new tab. */
          const mouseEvent = e;
          if (mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey || mouseEvent.button === 1) return;
          e.preventDefault();
          isOpen() ? close() : open();
          return;
        }
        if (target.closest("[data-cart-close]")) {
          e.preventDefault();
          close();
          return;
        }
        const removeEl = target.closest("[data-cart-remove]");
        if (removeEl) {
          e.preventDefault();
          const line = removeEl.getAttribute("data-cart-remove");
          if (line) removeLine(line, removeEl);
          return;
        }
        if (isOpen() && target.closest("[data-nav-backdrop]")) {
          close();
        }
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && isOpen()) close();
      });

      document.addEventListener("cart:open", () => open());
      document.addEventListener("cart:close", () => close());
      document.addEventListener("cart:section", (e) => {
        const html = e && e.detail && e.detail.html;
        if (html) applySection(html);
      });
    }

    function initStickyState() {
      if (window.__stickyHeaderBound) return;
      const header = document.querySelector("[data-site-header]");
      if (!header || typeof IntersectionObserver !== "function") return;
      window.__stickyHeaderBound = true;

      const bar = header.querySelector(".site-header__inner");

      function syncHeaderHeight() {
        const h = bar ? bar.offsetHeight : header.offsetHeight;
        if (h) document.documentElement.style.setProperty("--site-header-height", h + "px");
      }
      syncHeaderHeight();
      window.addEventListener("resize", syncHeaderHeight);
      window.addEventListener("load", syncHeaderHeight);

      let sentinel = document.getElementById("__site-header-sentinel");
      if (!sentinel) {
        sentinel = document.createElement("div");
        sentinel.id = "__site-header-sentinel";
        sentinel.style.cssText = "position:absolute;top:0;left:0;height:1px;width:1px;pointer-events:none;visibility:hidden;";
        document.body.prepend(sentinel);
      }

      const observer = new IntersectionObserver(([entry]) => {
        header.classList.toggle("is-scrolled", !entry.isIntersecting);
      }, { rootMargin: "0px 0px 0px 0px", threshold: 0 });
      observer.observe(sentinel);

      /* Homepage only: the category rail drops in once the chosen section
         reaches the bar, and folds away again on the way back up. */
      const revealAt = parseInt(header.getAttribute("data-reveal-section") || "0", 10);
      if (revealAt > 0) {
        const sections = document.querySelectorAll('[id^="shopify-section-template--"]');
        const target = sections[revealAt - 1];
        if (target) {
          let queued = false;
          const measure = () => {
            queued = false;
            const barH = bar ? bar.offsetHeight : 0;
            header.classList.toggle("is-expanded", target.getBoundingClientRect().top <= barH);
          };
          const onReveal = () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(measure);
          };
          window.addEventListener("scroll", onReveal, { passive: true });
          window.addEventListener("resize", onReveal, { passive: true });
          window.addEventListener("load", onReveal);
          measure();
        }
      }
    }

    if (document.readyState !== "loading") init();
    else document.addEventListener("DOMContentLoaded", init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-hero]');
    heroes.forEach((hero) => {
      const slots = hero.querySelectorAll('[data-hero-slot]');
      const thumbs = hero.querySelectorAll('[data-hero-target]');
      if (!slots.length || !thumbs.length) return;
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const target = thumb.getAttribute('data-hero-target');
          slots.forEach((s) => {
            s.classList.toggle('is-active', s.getAttribute('data-hero-slot') === target);
          });
          thumbs.forEach((t) => {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-ig-stories]');
    sections.forEach((section) => {
      const modal = section.querySelector('[data-ig-modal]');
      const items = Array.from(section.querySelectorAll('[data-ig-open]'));
      if (!modal || items.length === 0) return;

      const slides = Array.from(modal.querySelectorAll('[data-ig-slide]'));
      const progressBars = Array.from(modal.querySelectorAll('.ig-stories__progress-bar'));
      const barAvatar = modal.querySelector('[data-ig-bar-avatar]');
      const barHandle = modal.querySelector('[data-ig-bar-handle]');
      const prevBtn = modal.querySelector('[data-ig-prev]');
      const nextBtn = modal.querySelector('[data-ig-next]');
      const closeEls = modal.querySelectorAll('[data-ig-close]');

      let active = -1;
      let lastFocus = null;

      function setActive(index) {
        if (index < 0 || index >= slides.length) return;
        slides.forEach((s, i) => { s.hidden = i !== index; });

        progressBars.forEach((bar, i) => {
          bar.classList.remove('is-done', 'is-active');
          if (i < index) bar.classList.add('is-done');
          else if (i === index) bar.classList.add('is-active');
        });

        const slide = slides[index];
        const handle = slide.dataset.username || '';
        const avatar = slide.dataset.avatar || '';
        if (barHandle) barHandle.textContent = handle;
        if (barAvatar) barAvatar.style.backgroundImage = avatar ? `url("${avatar}")` : 'none';

        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === slides.length - 1;

        active = index;
      }

      function open(index) {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('ig-stories-locked');
        setActive(index);
        // Focus close button so ESC + tab work predictably
        const closeBtn = modal.querySelector('.ig-stories__close');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        modal.hidden = true;
        document.body.classList.remove('ig-stories-locked');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      function go(delta) {
        const next = active + delta;
        if (next < 0) { close(); return; }
        if (next >= slides.length) { close(); return; }
        setActive(next);
      }

      items.forEach((item) => {
        item.addEventListener('click', () => {
          const i = parseInt(item.dataset.index, 10) || 0;
          open(i);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', () => go(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => go(1));
      closeEls.forEach((el) => el.addEventListener('click', close));

      document.addEventListener('keydown', (e) => {
        if (modal.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });

      // Tap zones + swipe on the viewport
      const viewport = modal.querySelector('[data-ig-viewport]');
      if (viewport) {
        let startX = null;
        let startY = null;
        let startTime = 0;
        let moved = false;

        viewport.addEventListener('pointerdown', (e) => {
          if (e.target.closest('a, button')) return;
          startX = e.clientX;
          startY = e.clientY;
          startTime = Date.now();
          moved = false;
        });
        viewport.addEventListener('pointermove', (e) => {
          if (startX === null) return;
          if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) moved = true;
        });
        viewport.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          const dt = Date.now() - startTime;
          const sx = startX;
          startX = null; startY = null;

          // Swipe down to close
          if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { close(); return; }
          // Horizontal swipe
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            go(dx > 0 ? -1 : 1);
            return;
          }
          // Tap (no significant movement, quick)
          if (!moved && dt < 350) {
            const rect = viewport.getBoundingClientRect();
            const ratio = (sx - rect.left) / rect.width;
            go(ratio < 0.35 ? -1 : 1);
          }
        });
        viewport.addEventListener('pointercancel', () => { startX = null; startY = null; });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-template]');
    if (!root) return;

    /* ---- Image gallery ---- */
    const mainImg = root.querySelector('[data-product-main-img]');
    const thumbs = root.querySelectorAll('[data-product-thumb]');
    const videos = root.querySelectorAll('[data-product-video]');
    function stopVideos() {
      videos.forEach((v) => {
        v.hidden = true;
        const vid = v.querySelector('video');
        if (vid) vid.pause();
        const iframe = v.querySelector('iframe');
        if (iframe) iframe.src = iframe.src; // reload to stop external playback
      });
    }
    function activateThumb(btn) {
      if (!btn) return;
      thumbs.forEach((t) => {
        t.classList.toggle('is-active', t === btn);
        t.setAttribute('aria-selected', t === btn ? 'true' : 'false');
      });
      const type = btn.getAttribute('data-media-type');
      if (type === 'video') {
        stopVideos();
        if (mainImg) mainImg.hidden = true;
        const id = btn.getAttribute('data-media-id');
        const target = root.querySelector('[data-product-video][data-media-id="' + id + '"]');
        if (target) {
          target.hidden = false;
          const vid = target.querySelector('video');
          if (vid) vid.play().catch(() => {});
        }
        return;
      }
      stopVideos();
      if (!mainImg) return;
      mainImg.hidden = false;
      swapMainImage(
        btn.getAttribute('data-src'),
        btn.getAttribute('data-srcset'),
        btn.getAttribute('data-alt')
      );
    }

    /* Crossfade rather than snap: preload the next shot, dim the current one,
       then swap once the bytes are in. Falls back to a plain swap if it fails. */
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let swapToken = 0;
    function swapMainImage(src, srcset, alt) {
      if (!mainImg || !src) return;
      const token = ++swapToken;
      const apply = () => {
        if (token !== swapToken) return;
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        if (alt) mainImg.alt = alt;
        requestAnimationFrame(() => mainImg.classList.remove('is-swapping'));
      };
      if (reduceMotion) { apply(); return; }
      const pre = new Image();
      if (srcset) pre.srcset = srcset;
      pre.src = src;
      mainImg.classList.add('is-swapping');
      if (pre.decode) {
        pre.decode().then(apply).catch(apply);
      } else {
        pre.onload = apply;
        pre.onerror = apply;
      }
    }

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => activateThumb(btn));
    });

    /* ---- Detail tabs ---- */
    const tabRoot = root.querySelector('[data-product-tabs]');
    if (tabRoot) {
      const tabs = Array.from(tabRoot.querySelectorAll('[data-product-tab]'));
      const panels = Array.from(tabRoot.querySelectorAll('[data-product-panel]'));
      const showTab = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const on = panel.id === tab.getAttribute('aria-controls');
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => showTab(tab));
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          e.preventDefault();
          showTab(next);
          next.focus();
        });
      });
    }

    /* ---- Quantity ---- */
    const qtyInput = root.querySelector('[data-qty-input]');
    const decBtn = root.querySelector('[data-qty-decrement]');
    const incBtn = root.querySelector('[data-qty-increment]');
    if (qtyInput) {
      if (decBtn) decBtn.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      if (incBtn) incBtn.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) + 1);
      });
    }

    /* ---- Size guide modal ---- */
    const sizeModal = root.querySelector('[data-size-guide-modal]');
    if (sizeModal) {
      const openers = root.querySelectorAll('[data-size-guide-open]');
      const closers = sizeModal.querySelectorAll('[data-size-guide-close]');
      const openModal = () => {
        sizeModal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      };
      const closeModal = () => {
        sizeModal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      };
      openers.forEach((b) => b.addEventListener('click', openModal));
      closers.forEach((b) => b.addEventListener('click', closeModal));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !sizeModal.hasAttribute('hidden')) closeModal();
      });
    }

    /* ---- Variant change ---- */
    /* The variants <script> is rendered outside [data-product-template], so query at document scope. */
    const variantsScript = document.querySelector('[data-product-variants]');
    if (!variantsScript) return;
    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const variantIdInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-product-compare-price]');
    const saleBadge = root.querySelector('[data-product-sale-badge]');
    const discountEl = root.querySelector('[data-product-discount]');
    const discountSaveEl = root.querySelector('[data-product-discount-save]');
    const savingsEl = root.querySelector('[data-product-savings]');
    const stockEl = root.querySelector('[data-product-stock]');
    const ctaBtn = root.querySelector('[data-product-cta]');
    const ctaLabel = root.querySelector('[data-product-cta-label]');
    const buyNowBtn = root.querySelector('[data-product-buy-now]');
    const buyNowLabel = root.querySelector('[data-product-buynow-label]');
    const skuEl = root.querySelector('[data-product-sku]');
    const metaEl = root.querySelector('[data-product-meta]');
    const ctaDefaultLabel = ctaLabel ? ctaLabel.textContent.trim() : 'Add to bag';

    function selectedOptions() {
      const opts = [];
      root.querySelectorAll('[data-option-position]').forEach((input) => {
        if (input.checked) {
          const pos = parseInt(input.dataset.optionPosition, 10);
          opts[pos - 1] = input.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find((v) =>
        v.options.length === opts.length &&
        v.options.every((o, i) => o === opts[i])
      );
    }

    function setHidden(el, hide) {
      if (!el) return;
      if (hide) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    }

    function update(variant) {
      if (!variant) {
        if (ctaBtn) ctaBtn.disabled = true;
        if (buyNowBtn) buyNowBtn.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'Unavailable';
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;

      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* noop */ }

      if (priceEl) priceEl.innerHTML = variant.price_formatted;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      setHidden(compareEl, !onSale);
      setHidden(saleBadge, !onSale);
      setHidden(savingsEl, !onSale);
      if (onSale) {
        if (compareEl) compareEl.innerHTML = variant.compare_at_price_formatted;
        const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        if (discountEl) discountEl.textContent = pct;
        if (discountSaveEl) discountSaveEl.textContent = pct;
      }

      if (ctaBtn && ctaLabel) {
        if (variant.available) {
          ctaBtn.disabled = false;
          ctaLabel.textContent = ctaDefaultLabel;
        } else {
          ctaBtn.disabled = true;
          ctaLabel.textContent = 'Sold out';
        }
      }
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      if (stockEl) {
        const tpl = document.createElement('span');
        let html = '';
        if (variant.available) {
          if (variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
            html = '<span class="product-template__stock-dot product-template__stock-dot--low" aria-hidden="true"></span>Only ' + variant.inventory_quantity + ' left';
          } else {
            html = '<span class="product-template__stock-dot" aria-hidden="true"></span>In stock';
          }
        } else {
          html = '<span class="product-template__stock-dot product-template__stock-dot--out" aria-hidden="true"></span>Sold out';
        }
        stockEl.innerHTML = html;
      }

      if (skuEl) {
        if (variant.sku) {
          skuEl.textContent = variant.sku;
          setHidden(metaEl, false);
        } else {
          setHidden(metaEl, true);
        }
      }

      /* Update color name display */
      root.querySelectorAll('[data-option-selected]').forEach((el) => {
        const pos = parseInt(el.dataset.optionSelected, 10);
        if (variant.options[pos - 1]) el.textContent = variant.options[pos - 1];
      });

      /* Switch image when variant has its own */
      if (variant.featured_image && variant.featured_image.id && mainImg) {
        const matchingThumb = root.querySelector('[data-product-thumb][data-media-type="image"][data-media-id="' + variant.featured_image.id + '"]');
        if (matchingThumb) {
          activateThumb(matchingThumb);
        } else if (variant.featured_image.src) {
          swapMainImage(variant.featured_image.src, variant.featured_image.srcset, variant.featured_image.alt);
        }
      }
    }

    root.querySelectorAll('[data-option-position]').forEach((input) => {
      input.addEventListener('change', () => update(findVariant(selectedOptions())));
    });

    /* ---- AJAX add-to-cart, shared by both actions ---- */
    const productForm = root.querySelector('[data-product-form]');
    if (productForm) {
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      async function addToCart() {
        const formData = new FormData(productForm);
        formData.set('sections', 'header');
        const res = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        return data;
      }

      function lock(on) {
        if (ctaBtn) ctaBtn.disabled = on;
        if (buyNowBtn) buyNowBtn.disabled = on;
      }

      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const origLabel = ctaLabel ? ctaLabel.textContent : '';
        lock(true);
        if (ctaLabel) ctaLabel.textContent = 'Adding…';

        try {
          const data = await addToCart();
          if (data.sections && data.sections.header) {
            document.dispatchEvent(new CustomEvent('cart:section', { detail: { html: data.sections.header } }));
          }
          document.dispatchEvent(new CustomEvent('cart:open'));
          if (ctaLabel) ctaLabel.textContent = 'Added';
        } catch (err) {
          if (ctaLabel) ctaLabel.textContent = (err && err.message) || 'Error';
        } finally {
          setTimeout(() => {
            if (ctaLabel) ctaLabel.textContent = origLabel;
            lock(false);
          }, 1400);
        }
      });

      /* The store checks out through an app, not through Shopify's own
         checkout: Shiprocket for shoppers in India, ShipMozo for everyone
         else. Both of them live on the cart drawer button, and the timezone
         script in the layout decides which of the two a shopper sees, so Buy
         now mirrors that decision and presses the same button the drawer
         would. The drawer is re-rendered by the add above, and ShipMozo swaps
         the checkout button in only once it sees it, so wait briefly for the
         button to turn up. */
      async function handOverToCheckoutApp() {
        const tz = (Intl.DateTimeFormat().resolvedOptions().timeZone) || '';
        const inIndia = tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta';

        if (inIndia) {
          const sr = window.shiprocketCheckoutEvents;
          if (!sr || typeof sr.buyCart !== 'function') return false;
        }

        const selector = inIndia
          ? '.shiprocket-headless .sr-headless-checkout'
          : '.smz-checkout-btn';

        for (let i = 0; i < 20; i += 1) {
          const appBtn = document.querySelector(selector);
          if (appBtn) {
            appBtn.click();
            return true;
          }
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        return false;
      }

      /* Buy now: add the line, then hand the shopper to the checkout app.
         Shopify's own checkout stays as the fallback for when neither app is
         on the page. */
      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', async () => {
          const origLabel = buyNowLabel ? buyNowLabel.textContent : '';
          lock(true);
          if (buyNowLabel) buyNowLabel.textContent = 'One moment…';
          try {
            const data = await addToCart();
            if (data.sections && data.sections.header) {
              document.dispatchEvent(new CustomEvent('cart:section', { detail: { html: data.sections.header } }));
            }

            if (await handOverToCheckoutApp()) {
              /* Their window is opening over the page. Put the button back so
                 it still works if the shopper closes that window again. */
              setTimeout(() => {
                if (buyNowLabel) buyNowLabel.textContent = origLabel;
                lock(false);
              }, 2000);
              return;
            }

            window.location.href = cartRoot + 'checkout';
          } catch (err) {
            if (buyNowLabel) buyNowLabel.textContent = (err && err.message) || 'Error';
            setTimeout(() => {
              if (buyNowLabel) buyNowLabel.textContent = origLabel;
              lock(false);
            }, 1400);
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
